import React from 'react';
import './footer.css';
import logo from '../../Assets/logo.webp';
import { Link } from 'react-scroll';
import Instagram from '../../Assets/instagram.svg';
import WhatsApp  from '../../Assets/whatsapp.svg';
import Facebook  from '../../Assets/facebook.svg';

const NAV = [
  { label: 'About Us',     to: 'About'     },
  { label: 'Gallery',      to: 'Education' },
  { label: 'Services',     to: 'projects'  },
  { label: 'Achievements', to: 'paper'     },
  { label: 'Reviews',      to: 'reviews'   },
  { label: 'Contact',      to: 'Contact'   },
];

const SERVICES = [
  'Wedding', 'Pre-Wedding', 'Engagement',
  'Baby Shower', 'Newborn', 'Birthday',
  'Fashion & Modelling', 'Architecture', 'Product', 'Drone',
];

const SOCIAL = [
  { icon: Instagram, href: 'https://www.instagram.com/shree_photos_films', label: 'Instagram' },
  { icon: WhatsApp,  href: 'https://wa.me/917383677715',                   label: 'WhatsApp'  },
  { icon: Facebook,  href: 'https://www.facebook.com/share/16v9LtdKjw/',   label: 'Facebook'  },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">

      {/* ── TOP WAVE ── */}
      <div className="footer-wave" aria-hidden="true">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,20 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="#FFF8F0"/>
        </svg>
      </div>

      {/* ── MAIN CONTENT ── */}
      <div className="footer-body">

        {/* Brand column */}
        <div className="footer-brand">
          <div className="footer-logo-wrap">
            <img src={logo} alt="Shree Photos Films" className="footer-logo" />
            <div className="footer-brand-text">
              <span className="footer-brand-primary">Shree Photos</span>
              <span className="footer-brand-secondary">Films</span>
            </div>
          </div>
          <p className="footer-tagline">
            Capturing moments that last forever — weddings, events, fashion &amp; more across Surat &amp; Gujarat.
          </p>
          <div className="footer-socials">
            {SOCIAL.map(({ icon, href, label }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                className="footer-social" aria-label={label}>
                <img src={icon} alt={label} />
              </a>
            ))}
          </div>
          <p className="footer-est">Est. 2017 · Surat, Gujarat</p>
        </div>

        {/* Quick links */}
        <div className="footer-col">
          <h4 className="footer-col-heading">Quick Links</h4>
          <ul className="footer-links">
            {NAV.map(({ label, to }) => (
              <li key={to}>
                <Link to={to} smooth duration={600} className="footer-link">
                  <span className="footer-link-arrow">›</span>{label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4 className="footer-col-heading">Services</h4>
          <ul className="footer-links">
            {SERVICES.map((s) => (
              <li key={s}>
                <Link to="projects" smooth duration={600} className="footer-link">
                  <span className="footer-link-arrow">›</span>{s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact info */}
        <div className="footer-col">
          <h4 className="footer-col-heading">Contact</h4>
          <ul className="footer-contact-list">
            <li>
              <span className="footer-contact-label">📞 Phone</span>
              <a href="tel:7383677715" className="footer-contact-val">+91 73836 77715</a>
            </li>
            <li>
              <span className="footer-contact-label">✉️ Email</span>
              <a href="mailto:shreephotosfilms@gmail.com" className="footer-contact-val">
                shreephotosfilms@gmail.com
              </a>
            </li>
            <li>
              <span className="footer-contact-label">📍 Address</span>
              <a href="https://maps.app.goo.gl/paRc42yqn1xfKDfh7" target="_blank"
                rel="noopener noreferrer" className="footer-contact-val">
                Shop No. 09, Olympia, Shreejinagari Road, opp. Piramyd Stone Gallery, Jahangirabad, Sima Nagar, Surat, Gujarat 395009
              </a>
            </li>
          </ul>
        </div>

      </div>

      {/* ── DIVIDER ── */}
      <div className="footer-divider">
        <span />
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#C9A84C">
          <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4z"/>
        </svg>
        <span />
      </div>

      {/* ── BOTTOM BAR ── */}
      <div className="footer-bottom">
        <p className="footer-copy">
          © {year} <strong>Shree Photos Films</strong>. All Rights Reserved.
        </p>
        <p className="footer-credit">
          Made with ❤️ in Surat, Gujarat
        </p>
      </div>

    </footer>
  );
};

export default Footer;
